import AuthCard from '@/components/AuthCard';

export default function Login({ onLogin, onForgotPassword, defaultMode = 'login' }) {
  return (
    <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center p-4 relative">
      {/* Subtle gradient background */}
      <div className="fixed inset-0 bg-gradient-to-br from-[#0a0a0c] via-[#0d0d10] to-[#0a0a0c] pointer-events-none" />
      <div
        className="fixed inset-0 opacity-[0.015] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />
      <div className="relative z-10 w-full flex justify-center">
        <AuthCard
          onLogin={onLogin}
          onForgotPassword={onForgotPassword}
          defaultMode={defaultMode}
          variant="page"
        />
      </div>
    </div>
  );
}
